var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{directives:[{name:"resize",rawName:"v-resize",value:(_vm.DomResize),expression:"DomResize"}],ref:"targetwrapper",staticClass:"target-wrap",class:((_vm.getClass(_vm.itemInfos)) + " " + (_vm.targetRightViewClass('target')))})}
var staticRenderFns = []

export { render, staticRenderFns }